import { render, staticRenderFns } from "./TabletOrderDetail.vue?vue&type=template&id=01023c29"
import script from "./TabletOrderDetail.vue?vue&type=script&lang=js"
export * from "./TabletOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./TabletOrderDetail.vue?vue&type=style&index=0&id=01023c29&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports